import React from 'react'
import { Card, Stack, Alert } from '@mui/material'
import WildfireSummary from './wildfire/WildfireSummary'
import WildfireFWIDays from './wildfire/WildfireFWIDays'

const PropertyWildfire: React.FC<any> = ({ propertyId, emissionTier }) => {
  if (!propertyId) return <Alert severity="info">Select a property to view wildfire metrics.</Alert>

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <WildfireSummary propertyId={propertyId} emissionTier={emissionTier} />
      </Card>
      <Card sx={{ p: 3 }}>
        <WildfireFWIDays propertyId={propertyId} emissionTier={emissionTier} />
      </Card>
    </Stack>
  )
}

export default PropertyWildfire
